export enum EditableFieldActionType {
  UpdateField = 'UpdateField',
  UpdateMultipleField = 'UpdateMultipleField',
}
